export default function({ state, commit, dispatch }, query) {
    // Optimization: if all patients have been loaded, further queries are not necessary
    if (state.loadedAllProviderPatients || state.loadingAllProviderPatients)
        return

    commit('startLoadingAllProviderPatients')

    dispatch('loadHistoryPatientList')

    return Promise.all(
        [
            ...state.providers.map((provider) => dispatch('loadLineup', { id: provider.provider }))
        ]
    )
    .then((response) => {
        commit('finishLoadingAllProviderPatients')
    })
    .catch((error) => {
        commit('finishLoadingAllProviderPatients')
    })

}

export const loadHistoryPatientList = ({ state, commit, dispatch, rootState }) => {
    return Promise.all([...state.providers.map((provider) => {
        try {
            if(provider.profile && Array.isArray(provider.profile)) {
                if(provider.profile.some(({id}) => id === 'v0_regenerative-medicine---landrum'))
                    return dispatch('loadProviderPatients', { id: provider.provider, all: true})
            }
        } catch (error) {
            console.error('Error testing for hardcoded profile', error)
        }
        
        return  dispatch('loadProviderPatients', { id: provider.provider })
    })])
}